import { ResultsOverview } from "@/components/templates/ResultsOverview";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/$organizationKey/$dossierId/$researchProjectId/results/$researchParticipationId/"
)({
  component: ResultsPage,
});

function ResultsPage() {
  const { researchProjectId, researchParticipationId } = Route.useParams();

  return <ResultsOverview researchProjectId={researchProjectId} researchParticipationId={researchParticipationId} />;
}
